import { em, math } from 'polished'
import styled, { css } from 'styled-components'

export const SSHandlerSideMenu = styled.div`
  padding-top: ${p => math(`${p.theme.blocks.menuHeightMd} * 2 - ${em(15)}`)};
  padding-bottom: ${em(50)};
`

export const SSHandlerSideMenuList = styled.ul`
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
`

export const TextBox = styled.div`
  padding-top: ${em(15)};
  padding-bottom: ${em(15)};
`

export const Underline = styled.div`
  position: relative;
  top: -1px;
  width: 100%;
  height: 1px;
  background: ${p => p.theme.colors.grayOp07};

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 1px;
    background: ${p => p.theme.colors.bodyColor};
    transition-property: width;
    transition-duration: ${p => p.theme.animation.timeStandard};
    transition-timing-function: ease-in;
  }
`

export const SSHandlerSideMenuItem = styled.li`
  transition: opacity 0.3s;
  cursor: pointer;
  opacity: 0.4;

  ${p => p.theme.mq.hover} {
    &:hover {
      opacity: 1;

      ${Underline}:after {
        width: 100%;
      }
    }
  }

  ${({ isActive }) =>
    isActive &&
    css`
      opacity: 1;

      ${Underline}:after {
        width: 100%;
      }
    `}
`
